import axios from "axios";
import { LOGININFO_URL } from "../constant";
const { decorate, observable, action } = require("mobx");
class Logininfo {
  list = [];

  async getList() {
    try {
      let response = await axios.get(LOGININFO_URL);
      let data = await response.data;
      this.list = data;
    } catch (error) {
      throw error;
    }
  }
  async addInfo(data) {
    try {
      let response = await axios.post(LOGININFO_URL, {
        locname: data.locname,
        bigo: data.bigo,
        userid: data.userid,
        userpw: data.userpw
      });
      await this.getList();
      return response;
    } catch (error) {
      throw error;
    }
  }
  async updateInfo(data) {
    try {
      let response = await axios.put(LOGININFO_URL, {
        data: data
      });
      await this.getList();
      return response;
    } catch (e) {
      throw e;
    }
  }
  async deleteInfo(data) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      let response = await axios.delete(
        LOGININFO_URL,
        {
          data: { id: data._id }
        },
        config
      );
      await this.getList();
      return response;
    } catch (error) {
      throw error;
    }
  }
}

decorate(Logininfo, {
  list: observable,
  getList: action,
  addInfo: action,
  deleteInfo: action,
  updateInfo: action
});

const init = new Logininfo();
export default init;
